import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const getProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const getCategories = () => api.get("/categories").then((r) => r.data);
export const checkPromo = (code, subtotal) => api.post("/promo/check", { code, subtotal }).then((r) => r.data);
export const createOrder = (payload) => api.post("/orders", payload).then((r) => r.data);
export const subscribeNewsletter = (payload) => api.post("/newsletter", payload).then((r) => r.data);
export const sendContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const requestVentePrivee = (payload) => api.post("/ventes-privees", payload).then((r) => r.data);

export const authRegister = (payload) => api.post("/auth/register", payload).then((r) => r.data);
export const authLogin = (payload) => api.post("/auth/login", payload).then((r) => r.data);
export const authGoogle = (sessionId) => api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } }).then((r) => r.data);
export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then((r) => r.data);
export const getMyOrders = () => api.get("/orders/mine").then((r) => r.data);

export const createPaymentCheckout = (payload) => api.post("/payments/checkout", payload).then((r) => r.data);
export const getCheckoutQuote = (items, promo_code = null) => api.post("/payments/quote", { items, promo_code }).then((r) => r.data);
export const getPaymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data);

export const getPaypalConfig = () => api.get("/paypal/config").then((r) => r.data);
export const createPaypalOrder = (payload) => api.post("/paypal/create-order", payload).then((r) => r.data);
export const capturePaypalOrder = (orderId) => api.post(`/paypal/capture/${orderId}`).then((r) => r.data);

// --- Admin CJdropshipping (Module 2.2) ---
export const errMessage = (e, fallback = "Une erreur est survenue") => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  return d.message || fallback;
};
export const cjConnectionStatus = (force = false) => api.get("/admin/cj/connection", { params: force ? { force: true } : {} }).then((r) => r.data);
export const cjCategories = () => api.get("/admin/cj/categories").then((r) => r.data);
export const cjSearch = (payload) => api.post("/admin/cj/search", payload).then((r) => r.data);
export const cjProductDetail = (pid, category = "", manual_shipping_cost = null) => api.get(`/admin/cj/product/${pid}`, { params: { category, ...(manual_shipping_cost != null && manual_shipping_cost !== "" ? { manual_shipping_cost } : {}) } }).then((r) => r.data);
export const cjRewrite = (payload) => api.post("/admin/cj/rewrite", payload).then((r) => r.data);
export const cjImport = (payload) => api.post("/admin/cj/products/import", payload).then((r) => r.data);
export const cjListProducts = (params = {}) => api.get("/admin/cj/products", { params }).then((r) => r.data);
export const cjGetProduct = (id) => api.get(`/admin/cj/products/${id}`).then((r) => r.data);
export const cjPatchProduct = (id, payload) => api.patch(`/admin/cj/products/${id}`, payload).then((r) => r.data);
export const cjDeleteProduct = (id) => api.delete(`/admin/cj/products/${id}`).then((r) => r.data);
export const cjSetStock = (id, quantity) => api.post(`/admin/cj/products/${id}/stock`, { quantity }).then((r) => r.data);

// --- Module 2.3 : Synchronisation ---
export const syncStatus = () => api.get("/admin/sync/status").then((r) => r.data);
export const syncQueue = (params = {}) => api.get("/admin/sync/queue", { params }).then((r) => r.data);
export const syncLogs = (params = {}) => api.get("/admin/sync/logs", { params }).then((r) => r.data);
export const syncNotifications = (params = {}) => api.get("/admin/sync/notifications", { params }).then((r) => r.data);
export const syncMarkRead = (id) => api.post(`/admin/sync/notifications/${id}/read`).then((r) => r.data);
export const syncMarkAllRead = () => api.post("/admin/sync/notifications/read-all").then((r) => r.data);
export const syncRun = (type) => api.post("/admin/sync/run", { type }).then((r) => r.data);
export const syncClearQueue = () => api.post("/admin/sync/queue/clear").then((r) => r.data);
export const syncRetryFailed = () => api.post("/admin/sync/retry-failed").then((r) => r.data);
export const syncUpdateSettings = (payload) => api.post("/admin/sync/settings", payload).then((r) => r.data);
export const syncPriceApprovals = () => api.get("/admin/sync/price-approvals").then((r) => r.data);
export const syncResolveApproval = (id, action) => api.post(`/admin/sync/price-approvals/${id}`, { action }).then((r) => r.data);

// --- Module 3 : Commandes ---
export const ordersList = (params = {}) => api.get("/admin/orders", { params }).then((r) => r.data);
export const ordersStats = () => api.get("/admin/orders/stats").then((r) => r.data);
export const orderDetail = (id) => api.get(`/admin/orders/${id}`).then((r) => r.data);
export const orderResend = (id) => api.post(`/admin/orders/${id}/resend`).then((r) => r.data);
export const orderMarkDelivered = (id) => api.post(`/admin/orders/${id}/mark-delivered`).then((r) => r.data);
export const orderCancel = (id, reason) => api.post(`/admin/orders/${id}/cancel`, { reason }).then((r) => r.data);
export const orderNote = (id, note) => api.post(`/admin/orders/${id}/note`, { note }).then((r) => r.data);
export const orderAdvance = (id) => api.post(`/admin/orders/${id}/advance`).then((r) => r.data);
export const ordersRefreshTracking = () => api.post("/admin/orders/refresh-tracking").then((r) => r.data);
export const orderSimulate = (scenario) => api.post("/admin/orders/simulate", { scenario }).then((r) => r.data);

// --- Suivi commande client ---
export const getCustomerOrders = () => api.get("/customer/orders").then((r) => r.data);
export const getCustomerOrder = (orderNumber) => api.get(`/customer/orders/${orderNumber}`).then((r) => r.data);

export default api;
